import { deprecated } from "typesafe-actions";

import type { IIndustryConfig } from "@/shop/types/industry";

const { createStandardAction } = deprecated;

export const fetchIndustryConfig = createStandardAction("FETCH_INDUSTRY_CONFIG")();
export const fetchIndustryConfigStart = createStandardAction("FETCH_INDUSTRY_CONFIG_START")();
export const fetchIndustryConfigSuccess = createStandardAction("FETCH_INDUSTRY_CONFIG_SUCCESS").map((payload: IIndustryConfig) => ({ payload }));
export const fetchIndustryConfigFail = createStandardAction("FETCH_INDUSTRY_CONFIG_FAIL").map((payload: Error) => ({ payload, error: true }));
